// Core
import React, { useMemo } from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Plugins
import { formatValueWithUnit } from '../../../../../../../../plugins/general';

// Components
import { EquipmentSensorListItem } from '../../../../../../../../components/EquipmentSensorList';
import { Col } from '../../../../../../../../layout/elements/Col';
import { Row } from '../../../../../../../../layout/elements/Row';

// Modules
import { ListModule } from '../../../ListModule';

// View
import { VibrationProps } from './Vibration.types';
import { Container } from './Vibration.style';

function Vibration({
  className,
  testId,
  unitData,
}: VibrationProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();

  const sensors: EquipmentSensorListItem[] = useMemo(() => [
    {
      sensor: `${t('view.crusher.vsi.maintenance.setpoint.vibration.vibrationSensorHighAlarm')}`,
      setpoint: formatValueWithUnit(unitData?.spVibration1Alarm, '%'),
    },
    {
      sensor: `${t(
        'view.crusher.vsi.maintenance.setpoint.vibration.vibrationSensorDurationShutoff',
      )}`,
      setpoint: formatValueWithUnit(unitData?.spVibration1DurationAlarm, 's'),
    },
    {
      sensor: `${t('view.crusher.vsi.maintenance.setpoint.vibration.vibrationSensorWarning')}`,
      setpoint: formatValueWithUnit(unitData?.spVibration1Warning, '%'),
    },
    {
      sensor: `${t(
        'view.crusher.vsi.maintenance.setpoint.vibration.vibrationSensorDurationWarning',
      )}`,
      setpoint: formatValueWithUnit(unitData?.spVibration1DurationWarning, 's'),
    },
  ], [unitData, t]);

  return (
    <Container className={className} data-testid={testId}>
      <Row>
        <Col cols={12}>
          <ListModule
            title={`${t('view.crusher.vsi.maintenance.setpoint.vibration.title')}`}
            items={sensors}
          />
        </Col>
      </Row>
    </Container>
  );
}

export { Vibration };
